import React from 'react';
import {cutLongStrings} from '../../components/helpers/helpers';
import FaqsGridActions from './FaqsGridActions';

const FaqsGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'FAQ title',
        width: 450,
        accessor: 'title',
        sortable: false,
    },
    {
        Header: 'FAQ body',
        accessor: 'body',
        sortable: false,
        Cell: (props) =>
            props.value === null ? (
                <span> - </span>
            ) : (
                <span
                    className="noMargin noPadding"
                    dangerouslySetInnerHTML={{
                        __html: cutLongStrings(props.value),
                    }}
                />
            ),
    },
    {
        Header: 'Type',
        width: 200,
        accessor: 'faq_type_name',
        sortable: false,
    },
    {
        Header: 'Actions',
        width: 150,
        sortable: false,
        Cell: (props) => <FaqsGridActions rowProps={props} />,
    },
];

export default FaqsGridColumns;



// WEBPACK FOOTER //
// ./src/containers/faqs/FaqsGridColumns.jsx